const UNKNOWN = '<unknown>';

function shortHash(hash) {
  return hash ? hash.substring(0, 9) : UNKNOWN;
}

function formatTimestamp(isoString) {
  if (!isoString || isoString === UNKNOWN) {
    return UNKNOWN;
  }
  // Remove hyphens and colons from ISO timestamp
  return isoString.replace(/[-:]/g, '');
}

export function releaseId(Updates, Constants, env) {
  const isOTA = Updates?.isEmbeddedLaunch === false;
  // This will be true if the currently running update is the one embedded in the build, and not one downloaded from the
  // updates server.
  //
  // https://docs.expo.dev/versions/latest/sdk/updates/#updatesisembeddedlaunch

  const buildType = isOTA ? 'OTA' : 'BLD';

  // Get native app version
  const nativeVersion =
    Constants?.expoConfig?.version || Updates?.manifest?.extra?.expoClient?.version || UNKNOWN;

  let timestamp, fingerprintHash, commitHash;

  if (isOTA) {
    // OTA update: use update manifest data
    const manifest = Updates?.manifest;
    timestamp = manifest?.createdAt || UNKNOWN;
    fingerprintHash = Updates?.runtimeVersion || UNKNOWN;
    commitHash = manifest?.metadata?.commitHash || UNKNOWN;
  } else {
    // Native build: use embedded environment variables
    commitHash = env ? env.EXPO_PUBLIC_PTF_GIT_COMMIT_HASH : process.env.EXPO_PUBLIC_PTF_GIT_COMMIT_HASH;
    fingerprintHash = env
      ? env.EXPO_PUBLIC_PTF_EXPO_FINGERPRINT
      : process.env.EXPO_PUBLIC_PTF_EXPO_FINGERPRINT;
    timestamp = env ? env.EXPO_PUBLIC_PTF_BUILD_DATETIME : process.env.EXPO_PUBLIC_PTF_BUILD_DATETIME;

    // Provide fallbacks for native builds
    commitHash = commitHash || UNKNOWN;
    fingerprintHash = fingerprintHash || UNKNOWN;
    timestamp = timestamp || UNKNOWN;
  }

  // Format: nativeVersion:fingerprint:buildType:timestamp:commit
  return `${nativeVersion}:${shortHash(fingerprintHash)}:${buildType}:${formatTimestamp(
    timestamp
  )}:${shortHash(commitHash)}`;
}
